import { getIndexedProducts } from 'Util/Product';

import {
    CLEAR_SEARCH_RESULTS,
    UPDATE_SEARCH_BAR,
    UPDATE_SEARCH_LOAD_STATUS,
    UPDATE_SEARCH_PAGE,
    UPDATE_SEARCH_PAGE_LOAD_STATUS
} from './SearchBar.action';

/**
 * Override: add result var
 * @namespace PeggysagePwa/Store/SearchBar/Reducer/getInitialState */
export const getInitialState = () => ({
    productsInSearch: [],
    result: [],
    resultPage: [],
    isLoading: true,
    isLoadingPage: true
});

/**
 * Override: add result var with all results (not only products)
 * @namespace PeggysagePwa/Store/SearchBar/Reducer/SearchBarReducer */
export const SearchBarReducer = (
    state = getInitialState(),
    action
) => {
    switch (action.type) {
    case UPDATE_SEARCH_BAR:
        const { result: sourceResult, result: { products: { items: initialItems = [] } } } = action;

        // Transform object to array (we pass the original key to the child object)
        const result = Object.entries(sourceResult).map(([type, res]) => ({ ...res, type }));

        return {
            ...state,
            productsInSearch: getIndexedProducts(initialItems),
            result
        };

    case UPDATE_SEARCH_PAGE:
        const { resultPage: sourceResultPage } = action;

        // Transform object to array (we pass the original key to the child object)
        const resultPage = Object.entries(sourceResultPage).map(([type, res]) => ({ ...res, type }));

        return {
            ...state,
            resultPage
        };

    case UPDATE_SEARCH_LOAD_STATUS:
        const { isLoading } = action;

        return {
            ...state,
            isLoading
        };

    case UPDATE_SEARCH_PAGE_LOAD_STATUS:
        const { isLoadingPage } = action;

        return {
            ...state,
            isLoadingPage
        };

    case CLEAR_SEARCH_RESULTS:
        return {
            ...state,
            productsInSearch: getInitialState().productsInSearch,
            result: getInitialState().result
            // resultPage: getInitialState().resultPage
        };

    default:
        return state;
    }
};

export default SearchBarReducer;
